import { SubscribeSettingsPage } from '@/features/subscribe/subscribe-page'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/company/$companyId/settings/subscribe')({
	component: RouteComponent,
})

function RouteComponent() {
	const { companyId } = Route.useParams()
	return (
		<div className="pt-8">
			<SubscribeSettingsPage companyId={companyId} />
		</div>
	)
}
